module.exports = __webpack_public_path__ + "icon_likes-27b8551da2d56d81062818c035ed622e.png";